$(document).ready(function () {
  // cookies  code start *************************
  function getValueFromLocalStorage(name) {
    return localStorage.getItem(name);
  }
  var trackingId = getValueFromLocalStorage("trackingId");
  var get_trackingid = trackingId + "_track";
  // cookies  code end  *********************************
  var customer_email = $("body").attr("customeremail");
  var currentURL = window.location.href;
  var urlParams = new URLSearchParams(new URL(currentURL).search);
  var utm_parameter = urlParams.get("utm_source");
  if (!utm_parameter) {
    utm_parameter = "ECOMM";
  }
  var colorName = $(".form__label__bold .color-name").text();
  var updatedColor = colorName.replace("-", "");

  var anchorTag = $("#footer-atc");
  if (anchorTag.length) {
    anchorTag.attr("colour", updatedColor);
    anchorTag.attr("source", utm_parameter);
  }

  var $productGrid = document.querySelector("#ProductGridContainer") || null;
  window.initPartnerSlider = function () {
    $(".partner_slider_new").each(function (key, val) {
      var id1 = "";
      var sliderId_1 = "";
      var id1 = $(this).attr("id");
      var sliderId_1 = "#" + id1;
      if ($(sliderId_1).hasClass("slick-initialized")) {
      } else {
        $(sliderId_1).slick({
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: false,
          prevArrow: $("#l_" + id1),
          nextArrow: $("#r_" + id1),
          variableWidth: true,
          speed: 1000,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
                infinite: false,
                variableWidth: true,
                speed: 1000,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: false,
                variableWidth: true,
                speed: 1000,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                variableWidth: true,
                speed: 500,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                variableWidth: true,
                speed: 500,
              },
            },
          ],
        });

        // Remove aria-describedby from slick slides
        setTimeout(() => {
          const slickSlides = $(sliderId_1).find(".slick-list .slick-slide");
          adaFormatSlickSlides(slickSlides);
        }, 250);
      }

      $("#l_" + id1).hide();
      $(sliderId_1).on("afterChange", function (event, slick, currentSlide) {
        if (currentSlide === 0) {
          $("#l_" + id1).hide();
        } else {
          $("#l_" + id1).show();
        }
      });
    });
  };
  window.initPartnerSlider();

  /* Starts Product Slider - Karthikeyan */
  //  setInterval(function() {
  window.initProductSlider = function () {
    $(".product-list-contain").each(function (key, val) {
      var id = $(this).attr("id");
      var sliderId = "#" + id;
      $(sliderId)
        .not(".slick-initialized")
        .slick({
          variableWidth: true,
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: $(this).parent().find(".prev"),
          nextArrow: $(this).parent().find(".next"),
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
              },
            },
          ],
        });

      // Remove aria-describedby from slick slides
      setTimeout(() => {
        const slickSlides = $(sliderId).find(".slick-list .slick-slide");
        adaFormatSlickSlides(slickSlides);
      }, 250);
      //}, 500);
    });
  };
  window.initProductSlider();
  /* Ends Product Slider - Karthikeyan */

  $(document).on("click", ".freq-select-products", function () {
    if ($(".button-cart-frequent").attr("product-list") == "Cart Page") {
      var productList = "ATTACH :: Cart Page";
    } else {
      var mpn_handle = $("#mpn_handle").val();
      var productList = "Shopify Rec :: " + mpn_handle;
    }
    localStorage.setItem("product-click", productList);
  });

  $(document).on("change", ".frequent-products-checkbox", function () {
    var checkLength = $("input[name='frequent-products-pdp']:checked").length;
    $("#checked-products").text(checkLength);
    if (checkLength == 0) {
      $("#card-button").prop("disabled", true);
    } else {
      $("#card-button").prop("disabled", false);
    }
    var product_id = $(this).val();
    var prodtitle = $("#title_" + product_id).val();
    var prodMPN = $("#product_mpn_handle_" + product_id).val();
    var prodType = $(".card_product_category_" + product_id).val();
    var prodCurrency = $(".card_product_currency_" + product_id).attr("value");
    var prodPrice = $(".card_product_price_" + product_id).attr("value");
    var compareprice = $(".card_product_compare_" + product_id).attr("value");
    var prodSku = $(".card_product_sku_" + product_id).attr("value");
    prodPrice = Number(prodPrice.replace(/[^0-9.-]+/g, ""));
    prodPrice = parseFloat(prodPrice);
    var prodSku = $(".card_product_sku_" + product_id).attr("value");
    if ($(".button-cart-frequent").attr("product-list") == "Cart Page") {
      var productList = "ATTACH :: Cart Page";
    } else {
      var mpn_handle = $("#mpn_handle").val();
      var productList = "Shopify Rec :: " + mpn_handle;
    }
    localStorage.setItem("product-click", productList);
    dataLayer.push({
      ecommerce: null,
    });
    dataLayer.push({
      event: "select_item",
      ecommerce: {
        item_list_name: productList,
        items: [
          {
            item_id: prodSku,
            item_name: prodtitle,
            item_category: prodType,
            price: prodPrice,
            quantity: 1,
          },
        ],
      },
    });
  });

  $(document).on("click", "#card-button", function (event) {
    event.preventDefault();
    $(".button-cart-frequent").attr("aria-disabled", true);
    $(".button-cart-frequent").addClass("loading");
    $(".loading-overlay__spinner-frequent").removeClass("hidden");
    var frequentProducts = [];
    var frequentProducts_ga = [];
    var tax_total_quantity = 0;
    var quncheck = [];
    var prodTitle = [];
    var value_price = 0;
    var prodCurrency = $("#prod_currency").val();
    $.each($("input[name='frequent-products-pdp']:checked"), function () {
      /* Order Product Limits - Karthikeyan */
      var prodId = $("#product_id_" + $(this).val()).val();
      var prodQuant = 1;
      var prodMaxqut = $("#product_max_quantity_" + $(this).val()).val();
      var prodtitle = $("#title_" + $(this).val()).val();
      var prodMPN = $("#product_mpn_handle_" + $(this).val()).val();
      var prod_handle = $("#card_product_handle_" + $(this).val()).val();
      var prodPreorder = $("#card_product_preorder_" + $(this).val()).val();
      var prodPreorderMessage = $(
        "#card_product_preorder_message_" + $(this).val()
      ).val();
      var prodTradeIn = $("#card_product_tradein_" + $(this).val()).val();
      if (prodMaxqut != "") {
        var maxQuant = checkMaxquantity(prodId);
        if (maxQuant != "") {
          var max_total_quantity = parseInt(prodQuant) + parseInt(maxQuant);
        } else {
          var max_total_quantity = parseInt(prodQuant);
        }

        if (max_total_quantity > prodMaxqut) {
          quncheck.push(1);
          prodTitle.push(prodtitle);
        }
      }
      var taxtags_fb = $("#tags_" + $(this).val()).val();
      var addtaxfree = taxtags_fb.indexOf("taxfree") != -1;
      if (addtaxfree == true) {
        tax_total_quantity++;
      }
      item = {};
      item["quantity"] = "quantity:1";
      item["id"] = $(this).val();
      item["properties"] = {
        _uuid: prod_handle,
        ...(prodPreorder === "true" && { _preOrder: "true" }),
        ...(prodPreorderMessage && { _preOrderMessage: prodPreorderMessage }),
        ...(prodTradeIn === "true" && { _tradeInEligible: "true" }),
      };
      frequentProducts.push(item);
      var prodType = $(".card_product_category_" + $(this).val()).val();

      var prodPrice = $(".card_product_price_" + $(this).val()).attr("value");
      var prodSku = $(".card_product_sku_" + $(this).val()).attr("value");
      var compareprice = $(".card_product_compare_" + $(this).val()).attr(
        "value"
      );
      var productList = $(".button-cart-frequent").attr("product-list");
      var mpn_handle = $("#mpn_handle").val();
      var shopify_rec = "Shopify Rec :: " + mpn_handle;
      prodPrice = Number(prodPrice.replace(/[^0-9.-]+/g, ""));
      value_price += parseFloat(prodPrice);
      value_price = parseFloat(value_price);
      var productPrice1 = parseFloat(prodPrice);
      item_ga = {};
      item_ga["item_id"] = prodSku;
      item_ga["item_name"] = prodtitle;
      item_ga["item_category"] = prodType;
      item_ga["item_list_name"] = shopify_rec;
      item_ga["price"] = parseFloat(productPrice1);
      item_ga["quantity"] = 1;
      frequentProducts_ga.push(item_ga);
    });

    if (jQuery.inArray(1, quncheck) !== -1) {
      var prod_title = prodTitle.join();
      alert(quantity_limit_error_message + " " + prod_title);
      $(".button-cart-frequent").attr("aria-disabled", false);
      $(".button-cart-frequent").removeClass("loading");
      $(".loading-overlay__spinner-frequent").addClass("hidden");
      return false;
    }
    /* VAT Product Limits - Karthikeyan */
    if (vat_free_day == true) {
      if (getCookie("total_quantity") == "") {
        var tax_total_quantity = parseInt(tax_total_quantity);
      } else {
        var tax_total_quantity =
          parseInt(tax_total_quantity) + parseInt(getCookie("total_quantity"));
      }
      if (tax_total_quantity > vat_free_quantity) {
        alert(vat_free_message);
        $(".button-cart-frequent").attr("aria-disabled", false);
        $(".button-cart-frequent").removeClass("loading");
        $(".loading-overlay__spinner-frequent").addClass("hidden");
        return false;
      }
    }
    // new patch 1.1.6 sandhya
    const adobeItems = frequentProducts.map((item) => {
      return {
        ...item,
        quantity: item.quantity?.replace("quantity:", "") || 1,
      };
    });
    // new patch 1.1.6 sandhya
    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "post",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        items: frequentProducts,
      }),
    })
      .then((response) => {
        response.json().then((d) => {
          var mpn_handle = $("#mpn_handle").val();
          var shopify_rec = "Shopify Rec :: " + mpn_handle;
          var exphone_fa = [];
          if (JSON.parse(localStorage.getItem("cart")) != null) {
            exphone_fa = JSON.parse(localStorage.getItem("cart"));
          }
          for (var i = 0; i < d.items.length; i++) {
            item_cart_fa = {};
            item_cart_fa["cart_item_id"] = d.items[i].key;
            item_cart_fa["cart_item_list_name"] = shopify_rec;
            item_cart_fa["cart_item_mpn"] = d.items[i].sku;
            exphone_fa.push(item_cart_fa);
          }
          // console.log("1");
          // console.log(exphone_fa);
          localStorage.setItem("cart", JSON.stringify(exphone_fa));
          // new patch 1.1.6 sandhya
          adobeTrackAddToCart({
            items: adobeItems,
            context: "Frequently Bought Together",
            $trigger: $("#card-button")[0],
          });
          // new patch 1.1.6 sandhya
        });

        // checkQuantity();
        $.get(
          `${window.Shopify.routes.root}cart?view=minicart`,
          function (itemData) {
            var item_count = jQuery(itemData)
              .find("#cart-notification-button .count")
              .text();
            if ($(".cart-count-bubble").length > 0) {
              $(".cart-count-bubble span").text(item_count);
            } else {
              $("#cart-icon-bubble").append(
                '<div class="cart-count-bubble"><span></span></div>'
              );
              $(".cart-count-bubble span").text(item_count);
            }
            $("#cart-notification").text("");
            var textreplace = "<div id='min-cart-replace'></div>";
            $("#cart-notification").append(textreplace);
            $("#cart-notification").replaceWith(itemData);
            $("#cart-notification").addClass("minicart-active");
          }
        );
        dataLayer.push({
          ecommerce: null,
        });
        dataLayer.push({
          event: "add_to_cart",
          ecommerce: {
            value: value_price,
            currency: prodCurrency,
            items: frequentProducts_ga,
          },
        });

        $(".button-cart-frequent").attr("aria-disabled", false);
        $(".button-cart-frequent").removeClass("loading");
        $(".loading-overlay__spinner-frequent").addClass("hidden");

        if (window.location.href.indexOf("/cart") > -1) {
          window.onCartUpdate();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        return false;
      });
    return false;
  });
  /* Ends Frequently add Products Karthikeyan */

  // casa start for Add to cart slider by shivam ****************************************************

  function getValueFromLocalStorage(name) {
    return localStorage.getItem(name);
  }
  var trackingId = getValueFromLocalStorage("trackingId");
  var get_trackingid = trackingId + "_track";

  function quickAddEvents() {
    $(".slider-form").click(function (evt) {
      evt.preventDefault();

      var anchorTag_a = $("#slider-form-product");
      if (anchorTag_a.length) {
        anchorTag_a.attr("source", utm_parameter);
      }

      var get_quantity_a = $("#slider-form-product").attr("quantity");
      var get_productid_a = $("#slider-form-product").attr("productid");
      var get_productsku_a = $("#slider-form-product").attr("productsku");
      var get_productname_a = $("#slider-form-product").attr("productname");
      var get_brand_a = $("#slider-form-product").attr("brand");
      var get_category_a = $("#slider-form-product").attr("category");
      var get_subcategory_a = $("#slider-form-product").attr("subcategory");
      var get_material_a = $("#slider-form-product").attr("material");
      var get_source_a = $("#slider-form-product").attr("source");
      var get_mobile_no_a = $("body").attr("cus_mobile_no");
      var get_email_a = $("body").attr("customeremail");
      var get_tracking_id_a = $("#slider-form-product").attr("trackingid");

      // console.log("get_quantity_a :", get_quantity_a);
      // console.log("get_productid_a :", get_productid_a);
      // console.log("get_productsku_a :", get_productsku_a);
      // console.log("get_category_a :", get_category_a);
      // console.log("get_productname_a :", get_productname_a);
      // console.log("get_brand_a :", get_brand_a);
      // console.log("get_subcategory_a :", get_subcategory_a);
      // console.log("get_material_a :", get_material_a);
      // console.log("get_source_a :", get_source_a);

      var requestData_a = {
        mobile: get_mobile_no_a,
        email: customer_email,
        trackingId: get_trackingid,
        source: get_source_a,
        status: "cartAddition",
        productId: get_productid_a,
        productSku: get_productsku_a,
        productName: get_productname_a,
        category: get_category_a,
        subCategory: get_subcategory_a,
        brand: get_brand_a,
        colour: "",
        material: get_material_a,
        quantity: get_quantity_a,
        storeName: "shopify",
      };

      //POST request
      fetch("https://api.iplanet.one/casa/Addproduct_to_cart", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData_a),
      })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          console.log("ATC Data sent successfully on CASA !!", response);
        })
        .catch((error) => {
          console.error("Error: ", error);
        });

      // casa END for Add to cart slider by shivam ****************************************************

      var mpn_handle = $("#mpn_handle").val();
      /* Order Product Limits - Karthikeyan */
      var pageName = window.location.href;
      var prodId = $(this).attr("data-productid");
      var prodQuant = 1;
      var prodMaxqut = $(this).attr("data-productmaxquantity");
      var cartpage = $(this).attr("data-cartpage");
      if (cartpage == "Cart Page") {
        var attach = "ATTACH :: Cart Page";
      } else {
        var attach = "ATTACH :: ";
      }
      if (prodMaxqut != "") {
        var maxQuant = checkMaxquantity(prodId);
        if (maxQuant != "") {
          var max_total_quantity = parseInt(prodQuant) + parseInt(maxQuant);
        } else {
          var max_total_quantity = parseInt(prodQuant);
        }
        if (max_total_quantity > prodMaxqut) {
          alert(quantity_limit_error_message);
          return false;
        }
      }
      var slider_variantid = $(this).attr("data-variantid");
      var slider_tag = $(this).attr("data-tag");
      //souvik code for product list tracking starts
      var collection_name = $(this).attr("data-collection");
      var main_product_sku = $(this).attr("data-productsku");
      if (pageName.includes("products")) {
        var mpn_handle = $("#mpn_handle").val();
        var productList = mpn_handle;
      } else if (pageName.includes("search")) {
        var productList = "Search Results";
      } else {
        var productList = formatString($(this).attr("data-productlist"));
      }
      var productCategory = $(this).attr("data-producttype");
      var productPrice = $(this).attr("data-productprice");
      var productcomPrice = $(this).attr("data-productcompprice");
      var productCurrency = $(this).attr("data-productcurrency");
      var productTitle = $(this).attr("data-producttitle");
      var productMPN = $(this).attr("data-productMPN");
      var productHandle = $(this).attr("data-producthandle");
      var productPreOrder = $(this).attr("data-productpreorder");
      var productPreOrderMessage = $(this).attr("data-productpreordermessage");
      var productTradeIn = $(this).attr("data-producttradein");
      //souvik code for product list trackingends

      /* VAT Product Limits - Karthikeyan */
      if (vat_free_day == true) {
        var addtaxfree = slider_tag.indexOf("taxfree") != -1;
        if (addtaxfree == true) {
          if (getCookie("total_quantity") >= vat_free_quantity) {
            alert(vat_free_message);
            return false;
          }
        }
      }
      $("#slider-form-" + slider_variantid).attr("aria-disabled", true);
      $("#slider-form-" + slider_variantid).addClass("loading");
      $(".loading-overlay__spinner-frequent").removeClass("hidden");

      // new patch 1.1.6 sandhya
      var uid = productHandle;
      const props = {
        _uuid: uid,
        ...(productPreOrder === "true" && { _preOrder: "true" }),
        ...(productPreOrderMessage && {
          _preOrderMessage: productPreOrderMessage,
        }),
        ...(productTradeIn === "true" && { _tradeInEligible: "true" }),
      };

      var items = [
        {
          id: slider_variantid,
          quantity: 1,
          properties: props,
        },
      ];

      const adobeItems = [];
      items.forEach((item) => {
        adobeItems.push({
          id: item.id,
          quantity: item.quantity,
        });
      });
      // new patch 1.1.6 sandhya

      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "post",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: slider_variantid,
              quantity: 1,
              properties: {
                _uuid: productHandle,
                ...(productPreOrder === "true" && { _preOrder: "true" }),
                ...(productPreOrderMessage && {
                  _preOrderMessage: productPreOrderMessage,
                }),
                ...(productTradeIn === "true" && { _tradeInEligible: "true" }),
              },
            },
          ],
        }),
      })
        .then((response) => {
          response.json().then((d) => {
            cartCookie(productMPN, d.items[0].key, prod_list);
          });

          //checkQuantity();
          if (cartpage == "Cart Page") {
            var prod_list = attach;
          } else if (pageName.includes("search")) {
            var prod_list = productList;
          } else {
            var prod_list = attach + productList;
          }

          //souvik code for product list tracking starts
          triggerGAAddToCart(
            productcomPrice,
            main_product_sku,
            productTitle,
            productCategory,
            prod_list,
            productCurrency,
            productPrice,
            prodQuant,
            main_product_sku,
            slider_variantid
          );
          //souvik code for product list tracking ends
          // new patch 1.1.6 sandhya
          adobeTrackAddToCart({
            items: adobeItems,
            context: "Quick Add",
            $trigger: this,
          });
          // new patch 1.1.6 sandhya

          if (cartpage == "Cart Page") {
            window.onCartUpdate({ scrollToTop: true });
            return false;
          }
          $.get(
            `${window.Shopify.routes.root}cart?view=minicart`,
            function (itemData) {
              var item_count = jQuery(itemData)
                .find("#cart-notification-button .count")
                .text();
              if ($(".cart-count-bubble").length > 0) {
                $(".cart-count-bubble span").text(item_count);
              } else {
                $("#cart-icon-bubble").append(
                  '<div class="cart-count-bubble"><span></span></div>'
                );
                $(".cart-count-bubble span").text(item_count);
              }
              $("#cart-notification").text("");
              var textreplace = "<div id='min-cart-replace'></div>";
              $("#cart-notification").append(textreplace);
              $("#cart-notification").replaceWith(itemData);
              $("#cart-notification").addClass("minicart-active");
            }
          );
          $("#slider-form-" + slider_variantid).attr("aria-disabled", false);
          $("#slider-form-" + slider_variantid).removeClass("loading");
          $(".loading-overlay__spinner-frequent").addClass("hidden");
        })
        .catch((error) => {
          console.error("Error:", error);
          return false;
        });
      return false;
    });
  }

  quickAddEvents();
  window.quickAddEvents = quickAddEvents;

  /*Add Applecare on cart page functionality  starts here - added by Hema*/
  $(document).on("click", ".add-cart-apple-care", function (e) {
    e.preventDefault();
    $(this).prop("disabled", true);
    var add_button = $(this);
    var product_id = add_button.data("variantid");
    var main_product_index = add_button.data("forproduct");
    var wp_idx = add_button.data("forwproduct");
    var wp_key = add_button.data("forwkey");
    var previous_uid = add_button.data("uuid");
    var main_product_parent = $("#CartItem-" + main_product_index);
    var has_applcr_sku = main_product_parent.data("applecare_sku").trim();
    var has_applcr_handle = main_product_parent.data("applecare_handle");
    var has_sw_sku = main_product_parent.data("secwarranty_sku").trim();
    var has_sw_handle = main_product_parent.data("secwarranty_handle");
    var main_product_quantity = main_product_parent
      .find(".quantity__input")
      .val();
    var main_product_sku = add_button.data("skuparent");
    var main_product_handle = add_button.data("handleparent");
    var main_product_preorder = add_button.data("preorderparent");
    var main_product_preorder_message = add_button.data(
      "preordermessageparent"
    );
    var main_product_trade_in = add_button.data("tradeinparent");
    var main_product_key = add_button.data("keyparent");
    var aplCr_sku = add_button.data("skuaplcr");
    var applecarempn = add_button.data("mpnaplcr");
    var aplCr_handle = add_button.data("handleaplcr");
    var main_mpn_value = add_button.data("mpnparent");
    var additional_flag = add_button.data("reference");
    var main_product_tags = main_product_parent.find(".cart_tax_tags").val();
    const tradeInValue = $(main_product_parent).data("tradeInValue");
    const tradeInDevice = $(main_product_parent).data("tradeInDevice");

    var preorder = "";
    if (main_product_preorder) {
      preorder = '", "_preOrder": "true';
    }

    var preordermessage = "";
    if (main_product_preorder_message) {
      preordermessage =
        '", "_preOrderMessage": "' + main_product_preorder_message;
    }

    var trade_in = "";
    if (main_product_trade_in) {
      trade_in = '", "_tradeInEligible": "true';
    }

    let trade_in_value = "";
    if (tradeInValue) {
      trade_in_value = `", "_tradeIn_value": "${tradeInValue
        .toString()
        .replace(".", "")}`;
    }

    let trade_in_device = "";
    if (tradeInDevice) {
      trade_in_device = `", "_tradeIn_device": "${tradeInDevice}`;
    }

    //return false;
    if (additional_flag == "secwr") {
      if (has_applcr_sku) {
        //alert('main parent has applecare');
        var uid =
          main_product_handle + "-" + has_applcr_handle + "-" + aplCr_handle;
        if (tradeInDevice && !uid.includes("tradein")) {
          uid = uid + "-tradein";
        }
        var data =
          '{ "line":"' +
          main_product_index +
          '", "quantity": ' +
          main_product_quantity +
          ', "properties":{ "_uuid": "' +
          uid +
          preorder +
          preordermessage +
          trade_in +
          trade_in_value +
          trade_in_device +
          '", "_applecare_sku": "' +
          has_applcr_sku +
          '", "_applecare_handle": "' +
          has_applcr_handle +
          '", "_secWarranty_sku": "' +
          aplCr_sku +
          '", "_secWarranty_handle": "' +
          aplCr_handle +
          '" } }';
      } else {
        // alert('main parent has no applecare');
        var uid = main_product_handle + "-" + aplCr_handle;
        if (tradeInDevice && !uid.includes("tradein")) {
          uid = uid + "-tradein";
        }
        var data =
          '{ "line":"' +
          main_product_index +
          '", "quantity": ' +
          main_product_quantity +
          ', "properties":{ "_uuid": "' +
          uid +
          preorder +
          preordermessage +
          trade_in +
          trade_in_value +
          trade_in_device +
          '", "_secWarranty_sku": "' +
          aplCr_sku +
          '", "_secWarranty_handle": "' +
          aplCr_handle +
          '" } }';
      }
    } else {
      if (has_sw_sku) {
        // alert('main parent has sw');
        var uid =
          main_product_handle + "-" + aplCr_handle + "-" + has_sw_handle;
        if (tradeInDevice && !uid.includes("tradein")) {
          uid = uid + "-tradein";
        }
        var data =
          '{ "line":"' +
          main_product_index +
          '", "quantity": ' +
          main_product_quantity +
          ', "properties":{ "_uuid": "' +
          uid +
          preorder +
          preordermessage +
          trade_in +
          trade_in_value +
          trade_in_device +
          '", "_secWarranty_sku": "' +
          has_sw_sku +
          '", "_secWarranty_handle": "' +
          has_sw_handle +
          '", "_applecare_sku": "' +
          aplCr_sku +
          '", "_applecare_handle": "' +
          aplCr_handle +
          '" } }';
      } else {
        //  alert('main parent has no sw');
        var uid = main_product_handle + "-" + aplCr_handle;
        if (tradeInDevice && !uid.includes("tradein")) {
          uid = uid + "-tradein";
        }
        var data =
          '{ "line":"' +
          main_product_index +
          '", "quantity": ' +
          main_product_quantity +
          ', "properties":{ "_uuid": "' +
          uid +
          preorder +
          preordermessage +
          trade_in +
          trade_in_value +
          trade_in_device +
          '", "_applecare_sku": "' +
          aplCr_sku +
          '", "_applecare_handle": "' +
          aplCr_handle +
          '" } }';
      }
    }

    if (!has_applcr_sku && !has_sw_sku) {
      var wp_idx = 0;
    }

    $.ajax({
      url: `${window.Shopify.routes.root}cart/change.js`,
      type: "POST",
      data: data,
      contentType: "application/json",
      dataType: "json",
      success: function (data) {
        if (wp_idx >= 1) {
          if (has_applcr_sku) {
            var newWpKey =
              data.items.find(
                (item) =>
                  item.properties?._aplcr_main_product_sku ===
                    main_product_sku && item.properties?._uuid === previous_uid
              )?.key || wp_key;
            var data2 =
              '{ "id":"' +
              newWpKey +
              '", "quantity": ' +
              main_product_quantity +
              ', "properties": { "_aplcr_main_product_sku": "' +
              main_product_sku +
              '", "_aplcr_main_product_handle": "' +
              main_product_handle +
              '", "_uuid": "' +
              uid +
              trade_in_value +
              trade_in_device +
              '" } }';
          } else {
            var newWpKey =
              data.items.find(
                (item) =>
                  item.properties?._sw_main_product_sku === main_product_sku &&
                  item.properties?._uuid === previous_uid
              )?.key || wp_key;
            var data2 =
              '{ "id":"' +
              newWpKey +
              '", "quantity": ' +
              main_product_quantity +
              ', "properties": { "_sw_main_product_sku": "' +
              main_product_sku +
              '", "_sw_main_product_handle": "' +
              main_product_handle +
              '", "_uuid": "' +
              uid +
              trade_in_value +
              trade_in_device +
              '" } }';
          }
          $.ajax({
            url: `${window.Shopify.routes.root}cart/change.js`,
            type: "POST",
            data: data2,
            contentType: "application/json",
            dataType: "json",
            success: function (data) {
              if (additional_flag == "secwr") {
                if (has_applcr_sku) {
                  fetch(`${window.Shopify.routes.root}cart/add.js`, {
                    method: "post",
                    headers: {
                      "content-type": "application/json",
                    },
                    body: JSON.stringify({
                      items: [
                        {
                          id: product_id,
                          quantity: main_product_quantity,
                          properties: {
                            _sw_main_product_sku: main_product_sku,
                            _sw_main_product_handle: main_product_handle,
                            _uuid: uid,
                          },
                        },
                      ],
                    }),
                  })
                    .then((response) => {
                      // console.log(response.json());
                      window.onCartUpdate();
                    })
                    .catch((error) => {
                      console.error("Error:", error);
                      return false;
                    });
                } else {
                  fetch(`${window.Shopify.routes.root}cart/add.js`, {
                    method: "post",
                    headers: {
                      "content-type": "application/json",
                    },
                    body: JSON.stringify({
                      items: [
                        {
                          id: product_id,
                          quantity: main_product_quantity,
                          properties: {
                            _sw_main_product_sku: main_product_sku,
                            _sw_main_product_handle: main_product_handle,
                            _uuid: uid,
                          },
                        },
                      ],
                    }),
                  })
                    .then((response) => {
                      // console.log(response.json());
                      window.onCartUpdate();
                    })
                    .catch((error) => {
                      console.error("Error:", error);
                      return false;
                    });
                }
              } else {
                if (has_sw_sku) {
                  fetch(`${window.Shopify.routes.root}cart/add.js`, {
                    method: "post",
                    headers: {
                      "content-type": "application/json",
                    },
                    body: JSON.stringify({
                      items: [
                        {
                          id: product_id,
                          quantity: main_product_quantity,
                          properties: {
                            _aplcr_main_product_sku: main_product_sku,
                            _aplcr_main_product_handle: main_product_handle,
                            _uuid: uid,
                          },
                        },
                      ],
                    }),
                  })
                    .then((response) => {
                      // console.log(response.json());
                      window.onCartUpdate();
                    })
                    .catch((error) => {
                      console.error("Error:", error);
                      return false;
                    });
                } else {
                  fetch(`${window.Shopify.routes.root}cart/add.js`, {
                    method: "post",
                    headers: {
                      "content-type": "application/json",
                    },
                    body: JSON.stringify({
                      items: [
                        {
                          id: product_id,
                          quantity: main_product_quantity,
                          properties: {
                            _aplcr_main_product_sku: main_product_sku,
                            _aplcr_main_product_handle: main_product_handle,
                            _uuid: uid,
                          },
                        },
                      ],
                    }),
                  })
                    .then((response) => {
                      // console.log(response.json());
                      window.onCartUpdate();
                    })
                    .catch((error) => {
                      console.error("Error:", error);
                      return false;
                    });
                }
              }
            },
          });
        } else {
          if (additional_flag == "secwr") {
            if (has_applcr_sku) {
              fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: "post",
                headers: {
                  "content-type": "application/json",
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: product_id,
                      quantity: main_product_quantity,
                      properties: {
                        _sw_main_product_sku: main_product_sku,
                        _sw_main_product_handle: main_product_handle,
                        _uuid: uid,
                      },
                    },
                  ],
                }),
              })
                .then((response) => {
                  // console.log(response.json());
                  window.onCartUpdate();
                })
                .catch((error) => {
                  console.error("Error:", error);
                  return false;
                });
            } else {
              fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: "post",
                headers: {
                  "content-type": "application/json",
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: product_id,
                      quantity: main_product_quantity,
                      properties: {
                        _sw_main_product_sku: main_product_sku,
                        _sw_main_product_handle: main_product_handle,
                        _uuid: uid,
                      },
                    },
                  ],
                }),
              })
                .then((response) => {
                  // console.log(response.json());
                  window.onCartUpdate();
                })
                .catch((error) => {
                  console.error("Error:", error);
                  return false;
                });
            }
          } else {
            if (has_sw_sku) {
              fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: "post",
                headers: {
                  "content-type": "application/json",
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: product_id,
                      quantity: main_product_quantity,
                      properties: {
                        _aplcr_main_product_sku: main_product_sku,
                        _aplcr_main_product_handle: main_product_handle,
                        _uuid: uid,
                      },
                    },
                  ],
                }),
              })
                .then((response) => {
                  // console.log(response.json());
                  window.onCartUpdate();
                })
                .catch((error) => {
                  console.error("Error:", error);
                  return false;
                });
            } else {
              fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: "post",
                headers: {
                  "content-type": "application/json",
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: product_id,
                      quantity: main_product_quantity,
                      properties: {
                        _aplcr_main_product_sku: main_product_sku,
                        _aplcr_main_product_handle: main_product_handle,
                        _uuid: uid,
                      },
                    },
                  ],
                }),
              })
                .then((response) => {
                  console.log(response.json());
                  window.onCartUpdate();
                })
                .catch((error) => {
                  console.error("Error:", error);
                  return false;
                });
            }
          }
        }
      },
    });
  });
  /*Add Applecare on cart page functionality  ends here - added by Hema*/

  /*
    	Add Trade-In on cart page
    */
  $(document).on("click", ".add-cart-trade-in", function (e) {
    e.preventDefault();
    $(this).prop("disabled", true);
    const add_button = $(this);
    const tradeInValue = add_button.data("tradeInValue");
    const tradeInDevice = add_button.data("tradeInDevice");
    const main_product_id = add_button.data("parentId");
    const main_product_index = add_button.data("forproduct");
    const main_product_parent = $(`#${main_product_id}`);
    const main_product_quantity = main_product_parent
      .find(".quantity__input")
      .val();
    const main_product_sku = add_button.data("skuparent");
    const main_product_handle = add_button.data("handleparent");
    const main_product_preorder = add_button.data("preorderparent");
    const main_product_preorder_message = add_button.data(
      "preordermessageparent"
    );
    const main_product_trade_in = add_button.data("tradeinparent");
    const main_product_key = add_button.data("keyparent");
    const main_mpn_value = add_button.data("mpnparent");
    const additional_flag = add_button.data("reference");
    const main_product_tags = main_product_parent.find(".cart_tax_tags").val();

    let properties = $(this).data("itemProperties");

    if (main_product_preorder) properties._preOrder = "true";
    if (main_product_preorder_message)
      properties._preOrderMessage = main_product_preorder_message;
    if (tradeInDevice) properties._tradeInEligible = "true";
    if (tradeInValue)
      properties._tradeIn_value = tradeInValue.toString().replace(".", "");
    if (tradeInDevice) properties._tradeIn_device = tradeInDevice;

    if (
      tradeInDevice &&
      properties._uuid &&
      !properties._uuid.includes("tradein")
    ) {
      properties._uuid = properties._uuid + "-tradein";
    }

    const data_tradeIn = `{
        "line": ${main_product_index},
        "quantity": ${main_product_quantity},
        "properties": ${JSON.stringify(properties)}
      }`;

    $.ajax({
      url: `${window.Shopify.routes.root}cart/change.js`,
      type: "POST",
      data: data_tradeIn,
      contentType: "application/json",
      dataType: "json",
      success: function (data) {
        const oldUuid = properties?._uuid.split("-tradein")[0];
        const newUuid = properties?._uuid;

        if (!oldUuid || !newUuid || oldUuid === newUuid) return;

        const appleCareProductsThatNeedUpdating = data.items.find(
          (item) =>
            item.properties?._aplcr_main_product_sku &&
            item.properties?._uuid === oldUuid
        );
        const secWarrantyProductsThatNeedUpdating = data.items.find(
          (item) =>
            item.properties?._sw_main_product_sku &&
            item.properties?._uuid === oldUuid
        );

        async function updateAcSecProducts() {
          if (appleCareProductsThatNeedUpdating) {
            const newProperties = {
              ...appleCareProductsThatNeedUpdating.properties,
              _uuid: newUuid,
            };
            const newData = {
              id: appleCareProductsThatNeedUpdating.key,
              quantity: appleCareProductsThatNeedUpdating.quantity,
              properties: newProperties,
            };
            await fetch(`${window.Shopify.routes.root}cart/change.js`, {
              method: "POST",
              headers: {
                "content-type": "application/json",
              },
              body: JSON.stringify(newData),
            });
          }

          if (secWarrantyProductsThatNeedUpdating) {
            const newProperties = {
              ...secWarrantyProductsThatNeedUpdating.properties,
              _uuid: newUuid,
            };
            const newData = {
              id: secWarrantyProductsThatNeedUpdating.key,
              quantity: secWarrantyProductsThatNeedUpdating.quantity,
              properties: newProperties,
            };
            await fetch(`${window.Shopify.routes.root}cart/change.js`, {
              method: "POST",
              headers: {
                "content-type": "application/json",
              },
              body: JSON.stringify(newData),
            });
          }

          location.reload();
        }

        updateAcSecProducts();
      },
      error: function (xhr, status, error) {
        console.log(`Error: ${xhr.responseText}`);
      },
    });
  });

  /* sticky atc on pdp functionality  starts here - added by Hema*/
  var get_mobile = $("#footer-atc").attr("mobile");
  var get_productid = $("#footer-atc").attr("productid");
  var get_productsku = $("#footer-atc").attr("productsku");
  var get_productname = $("#footer-atc").attr("productname");
  var get_brand = $("#footer-atc").attr("brand");
  var get_quantity = $("#footer-atc").attr("quantity");
  var get_source = $("#footer-atc").attr("source");
  var get_colour = $("#footer-atc").attr("colour");
  var get_category = $("#footer-atc").attr("category");
  var get_subcategory = $("#footer-atc").attr("subcategory");
  var get_material = $("#footer-atc").attr("material");

  // start view_product CASA get all Atrributes by Sandhya********

  $(window).on("load", function () {
    var currentURLss = window.location.href;
    var product_parameter = currentURLss.includes("/products");
    if (product_parameter) {
      var formData = {
        mobile: get_mobile,
        email: customer_email,
        trackingId: get_trackingid,
        source: get_source,
        productId: get_productid,
        productSku: get_productsku,
        productName: get_productname,
        category: get_category,
        subCategory: get_subcategory,
        brand: get_brand,
        colour: get_colour,
        material: get_material,
        storeName: "shopify",
      };

      // POST request to the specified API endpoint
      // fetch("https://api.iplanet.one/casa/viewproduct", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify(formData),
      // })
      //   .then((response) => {
      //     return response.json();
      //   })
      //   .then((response) => {
      //     console.log(
      //       "View-product Data sent successfully on CASA !!",
      //       response
      //     );
      //   })
      //   .catch((error) => {
      //     console.error("Error: ", error);
      //   });
    }
  });

  // end view_product CASA get all Atrributes by Sandhya********

  $(document).on("click", "#footer-atc", function (evt) {
    evt.preventDefault();

    var requestData = {
      mobile: get_mobile,
      email: customer_email,
      trackingId: get_trackingid,
      source: get_source,
      status: "cartAddition",
      productId: get_productid,
      productSku: get_productsku,
      productName: get_productname,
      category: get_category,
      subCategory: get_subcategory,
      brand: get_brand,
      colour: get_colour,
      material: get_material,
      quantity: parseInt(get_quantity),
      storeName: "shopify",
    };

    //POST request
    // fetch("https://api.iplanet.one/casa/Addproduct_to_cart", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify(requestData),
    // })
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((response) => {
    //     console.log("ATC Data sent successfully on CASA !!", response);
    //   })
    //   .catch((error) => {
    //     console.error("Error: ", error);
    //   });

    // end add_to_cart CASA get all Atrributes by Sandhya

    /* Order Product Limits - Karthikeyan */
    var prodVariantID = $("#main-product-variant").val();
    var prodQuant = $("#prodQuantity").val();
    var total_qty = $("#total_qty_" + prodVariantID).val();
    /* VAT Product Limits - Karthikeyan */
    const isValidQty = checkQty();

    if (!isValidQty) {
      return false;
    }
    if (vat_free_day == true) {
      var taxtags = $("#tax_tags").val();
      var prodQuant = $("#prodQuantity").val();
      var addtaxfree = taxtags.indexOf("taxfree") != -1;
      if (getCookie("total_quantity") == "") {
        var tax_total_quantity = parseInt(prodQuant);
      } else {
        var tax_total_quantity =
          parseInt(prodQuant) + parseInt(getCookie("total_quantity"));
      }

      if (addtaxfree == true) {
        if (tax_total_quantity > vat_free_quantity) {
          alert(vat_free_message);
          return false;
        } else {
          addToCart("cart");
        }
      } else {
        addToCart("cart");
      }
    } else {
      addToCart("cart");
    }
    return false;
  });

  $(document).on(
    "click",
    ".js-checkout-button,.js-checkout-link",
    function (evt) {
      evt.preventDefault();
      //   var tttype = $(".shopify-payment-button__button").attr("type");
      var prodVariantID = $("#main-product-variant").val();
      var mpn_handle = $("#mpn_handle_" + prodVariantID).val();
      const isValidQty = checkQty();

      if (!isValidQty) {
        return false;
      }
      if (vat_free_day == true) {
        var taxtags = $("#tax_tags").val();
        var prodQuant = $("#prodQuantity").val();
        var addtaxfree = taxtags.indexOf("taxfree") != -1;

        if (getCookie("total_quantity") == "") {
          var tax_total_quantity = parseInt(prodQuant);
        } else {
          var tax_total_quantity =
            parseInt(prodQuant) + parseInt(getCookie("total_quantity"));
        }

        if (addtaxfree == true) {
          if (tax_total_quantity > vat_free_quantity) {
            alert(vat_free_message);
            return false;
          }
        }
      }
      if ($(".pdp_product_list").attr("value").indexOf("PLP ::") >= 0) {
        var proliststring = $(".pdp_product_list").attr("value");
      } else {
        var proliststring = formatString($(".pdp_product_list").attr("value"));
      }
      var productList = proliststring;
      // cartCookie(mpn_handle, prodVariantID, productList);

      $(".js-checkout-button,.js-checkout-link").attr("disabled", true);
      addToCart("buy");
    }
  );

  /* sticky atc on pdp functionality  ends here - added by Hema*/

  function addToCart(check_buy) {
    var $cartDrawer = document.querySelector("cart-drawer") || null;
    var taxtags = $("#tax_tags").val();
    var btn = $(this).find(".BUY_NOW_CLICKED");
    var buy_now_checker = btn.data("submit");
    /* Applecare PDP  starts here - added by Hema*/
    var isChecked = $("#add-apple-care").is(":checked");
    var isChecked2 = $("#add-secWarranty").is(":checked");
    var hasTradeIn =
      $("#selected-trade-in-value").val() !== undefined &&
      $("#selected-trade-in-value").val() !== "0" &&
      $("#selected-trade-in-device").val() !== "";
    const tradeInValue = $("#selected-trade-in-value").val() || ""; // Get Trade-In value
    const parsedTradeInValue = hasTradeIn
      ? parseInt(tradeInValue).toFixed(2).replace(".", "")
      : null; // Set parsed Trade-In value
    const tradeInDevice = $("#selected-trade-in-device").val() || ""; // Get Trade-In value
    var prodVariantID = $("#main-product-variant").val();
    var mpn_handle = $("#mpn_handle_" + prodVariantID).val();
    var productcomPrice = $("#compr_price_" + prodVariantID).val();
    var uuid = Math.random().toString(36).slice(2);

    const disablePdpButton = (disable) => {
      if (check_buy === "cart") {
        $("#footer-atc").attr("disabled", disable);
      }
    };

    if ($("#footer-atc")) {
      if ($("#footer-atc").hasClass("block_it")) {
        $(".indigo_check_container").addClass("show_indigo_container");
        return;
      }
    }

    // new patch 1.1.6 sandhya
    const adobeTrack = (items) => {
      adobeTrackAddToCart({
        items,
        context:
          check_buy === "cart" ? "PDP Add to Cart" : "Check out with Apple Pay",
        $trigger: check_buy === "cart" ? $("#footer-atc")[0] : null,
        triggerText: check_buy !== "cart" ? "Check out with Apple Pay" : null,
        triggerUrl:
          check_buy !== "cart"
            ? `${window.location.origin}${window.Shopify.routes.root}checkout`
            : null,
      });
    };
    // new patch 1.1.6 sandhya

    disablePdpButton(true);

    if (isChecked == true || isChecked2 == true || hasTradeIn === true) {
      if (isChecked == true && isChecked2 == true) {
        //  alert('both true');
        var prodMaxqut = $("#product_max_quantity").val();
        var applecareID = $("#apple-care-varid").val(); //Getting apple care id
        var applecaresku = $("#applecare-product-sku").val(); //Getting apple care sku
        var applecarempn = $("#applecare-product-mpn").val(); //Getting apple care mpn
        var applecarehandle = $("#applecare-product-handle").val(); //Getting apple care handle
        var secWarrantyID = $("#secWarranty-varid").val(); //Getting secWarranty id
        var secWarrantysku = $("#secWarranty-product-sku").val(); //Getting secWarranty sku
        var secWarrantympn = $("#secWarranty-product-mpn").val(); //Getting secWarranty mpn
        var secWarrantyhandle = $("#secWarranty-product-handle").val(); //Getting secWarranty handle
        var main_product_sku = $("#main-pro-sku").val(); //Getting MAIN PRODUCT SKU
        var main_product_handle = $("#main-pro-handle").val(); //Getting main product handle
        var main_product_preorder = $("#main-pro-preorder").val(); //Getting main product preorder value
        var main_product_preorder_message = $(
          "#main-pro-preorder-message"
        ).val(); //Getting main product preorder message value
        var main_product_trade_in = $("#main-pro-trade-in").val(); //Getting main product trade-in value
        var prodVariantID = $("#main-product-variant").val(); //Getting main product id
        var prodQuant = $("#prodQuantity").val(); //Getting main product QUANTITY
        var taxtags = $("#tax_tags").val();
        var uid =
          main_product_handle + "-" + applecarehandle + "-" + secWarrantyhandle;
        if (tradeInDevice && !uid.includes("tradein")) {
          uid = uid + "-tradein";
        }

        const props = {
          _applecare_sku: applecaresku,
          _applecare_handle: applecarehandle,
          _secWarranty_sku: secWarrantysku,
          _secWarranty_handle: secWarrantyhandle,
          _uuid: uid,
          ...(main_product_preorder === "true" && { _preOrder: "true" }),
          ...(main_product_preorder_message && {
            _preOrderMessage: main_product_preorder_message,
          }),
          ...(main_product_trade_in === "true" && { _tradeInEligible: "true" }),
        };

        if (hasTradeIn === true) {
          props._tradeIn_value = parsedTradeInValue;
          props._tradeIn_device = tradeInDevice;
          props._tradeInEligible = "true";
        }
        // new patch 1.1.6 sandhya
        const adobeItems = [
          {
            id: secWarrantyID,
            quantity: prodQuant,
          },
          {
            id: applecareID,
            quantity: prodQuant,
          },
          {
            id: prodVariantID,
            quantity: prodQuant,
          },
        ];
        // new patch 1.1.6 sandhya

        //alert(applecareID);
        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "post",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: secWarrantyID,
                quantity: prodQuant,
                properties: {
                  _sw_main_product_sku: main_product_sku,
                  _sw_main_product_handle: main_product_handle,
                  _uuid: uid,
                },
              },
              {
                id: applecareID,
                quantity: prodQuant,
                properties: {
                  _aplcr_main_product_sku: main_product_sku,
                  _aplcr_main_product_handle: main_product_handle,
                  _uuid: uid,
                },
              },
              {
                id: prodVariantID,
                quantity: prodQuant,
                properties: props,
              },
            ],
          }),
        })
          /* Applecare PDP  ends here - added by Hema*/
          .then((response) => {
            response.json().then((d) => {
              if ($(".pdp_product_list").attr("value").indexOf("PLP ::") >= 0) {
                var proliststring = $(".pdp_product_list").attr("value");
              } else {
                var proliststring = formatString(
                  $(".pdp_product_list").attr("value")
                );
              }
              var productList = proliststring;
              cartCookie(mpn_handle, d.items[2].key, productList);

              triggerGAAddToCart(
                productcomPrice,
                mpn_handle,
                productTitle,
                productCategory,
                productList,
                productCurrency,
                productPrice,
                prodQuant,
                main_product_sku,
                prodVariantID
              );
              if ($cartDrawer) {
                $cartDrawer.updateItems();
              }
              adobeTrack(adobeItems);
            });
            if (check_buy == "buy") {
              $.get(
                `${window.Shopify.routes.root}cart?view=minicart`,
                function (itemData) {
                  var item_count = jQuery(itemData)
                    .find("#cart-notification-button .count")
                    .text();
                  if ($(".cart-count-bubble").length > 0) {
                    $(".cart-count-bubble span").text(item_count);
                  } else {
                    $("#cart-icon-bubble").append(
                      '<div class="cart-count-bubble"><span></span></div>'
                    );
                    $(".cart-count-bubble span").text(item_count);
                  }
                  $("#cart-notification").text("");
                  var textreplace = "<div id='min-cart-replace'></div>";
                  $("#cart-notification").append(textreplace);
                  $("#cart-notification").replaceWith(itemData);
                  $("#cart-notification").addClass("minicart-active");
                  $("#cart-notification").css("visibility", "hidden");
                  $(".cart-count-bubble").css("visibility", "hidden");
                  window.location.href = `${window.Shopify.routes.root}checkout`;
                }
              );
            } else {
              $.get(
                `${window.Shopify.routes.root}cart?view=minicart`,
                function (itemData) {
                  var item_count = jQuery(itemData)
                    .find("#cart-notification-button .count")
                    .text();
                  if ($(".cart-count-bubble").length > 0) {
                    $(".cart-count-bubble span").text(item_count);
                  } else {
                    $("#cart-icon-bubble").append(
                      '<div class="cart-count-bubble"><span></span></div>'
                    );
                    $(".cart-count-bubble span").text(item_count);
                  }
                  $("#cart-notification").text("");
                  var textreplace = "<div id='min-cart-replace'></div>";
                  $("#cart-notification").append(textreplace);
                  $("#cart-notification").replaceWith(itemData);
                  $("#cart-notification").addClass("minicart-active");
                }
              );
              var main_product_sku = $("#main-pro-sku").val();

              var productCategory = $(".pdp_product_category").attr("value");
              var productCurrency = $(".pdp_product_currency").attr("value");
              var productPrice1 = $(".pdp_product_price").attr("value");
              var productPrice = $("#prod_price_" + prodVariantID).val();
              var productTitle = $(".pdp_product_title").attr("value");
              var prodQuant = $("#prodQuantity").val();
              //souvik code for product list trackingends
              //souvik code for product list tracking starts
              // cartCookie(mpn_handle, prodVariantID, productList);
              //souvik code for product list tracking ends
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            return false;
          })
          .finally(() => {
            disablePdpButton(false);
            // checkQuantity();
            //  submitButton.classList.remove('loading');
            //submitButton.removeAttribute('aria-disabled');
            //  this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
        //return false;
      } else if (isChecked == false && isChecked2 == true) {
        //  alert('Applecare false, sec warranty true');

        var secWarrantyID = $("#secWarranty-varid").val(); //Getting secWarranty id
        var secWarrantysku = $("#secWarranty-product-sku").val(); //Getting secWarranty sku
        var secWarrantympn = $("#secWarranty-product-mpn").val(); //Getting secWarranty mpn
        var secWarrantyhandle = $("#secWarranty-product-handle").val(); //Getting secWarranty handle
        var main_product_sku = $("#main-pro-sku").val(); //Getting MAIN PRODUCT SKU
        var main_product_handle = $("#main-pro-handle").val(); //Getting main product handle
        var main_product_preorder = $("#main-pro-preorder").val(); //Getting main product preorder value
        var main_product_preorder_message = $(
          "#main-pro-preorder-message"
        ).val(); //Getting main product preorder message value
        var main_product_trade_in = $("#main-pro-trade-in").val(); //Getting main product trade-in value
        var prodVariantID = $("#main-product-variant").val(); //Getting main product id
        var prodQuant = $("#prodQuantity").val(); //Getting main product QUANTITY
        var taxtags = $("#tax_tags").val();
        var uid = main_product_handle + "-" + secWarrantyhandle;
        if (tradeInDevice && !uid.includes("tradein")) {
          uid = uid + "-tradein";
        }

        const props = {
          _secWarranty_sku: secWarrantysku,
          _secWarranty_handle: secWarrantyhandle,
          _uuid: uid,
          ...(main_product_preorder === "true" && { _preOrder: "true" }),
          ...(main_product_preorder_message && {
            _preOrderMessage: main_product_preorder_message,
          }),
          ...(main_product_trade_in === "true" && { _tradeInEligible: "true" }),
        };

        if (hasTradeIn === true) {
          props._tradeIn_value = parsedTradeInValue;
          props._tradeIn_device = tradeInDevice;
          props._tradeInEligible = "true";
        }

        const adobeItems = [
          {
            id: secWarrantyID,
            quantity: prodQuant,
          },
          {
            id: prodVariantID,
            quantity: prodQuant,
          },
        ];

        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "post",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: secWarrantyID,
                quantity: prodQuant,
                properties: {
                  _sw_main_product_sku: main_product_sku,
                  _sw_main_product_handle: main_product_handle,
                  _uuid: uid,
                },
              },
              {
                id: prodVariantID,
                quantity: prodQuant,
                properties: props,
              },
            ],
          }),
        })
          /* Applecare PDP  ends here - added by Hema*/
          .then((response) => {
            response.json().then((d) => {
              if ($(".pdp_product_list").attr("value").indexOf("PLP ::") >= 0) {
                var proliststring = $(".pdp_product_list").attr("value");
              } else {
                var proliststring = formatString(
                  $(".pdp_product_list").attr("value")
                );
              }
              var productList = proliststring;
              cartCookie(mpn_handle, d.items[1].key, productList);
              triggerGAAddToCart(
                productcomPrice,
                mpn_handle,
                productTitle,
                productCategory,
                productList,
                productCurrency,
                productPrice,
                prodQuant,
                main_product_sku,
                prodVariantID
              );

              if ($cartDrawer) {
                $cartDrawer.updateItems();
              }
              adobeTrack(adobeItems);
            });
            if (check_buy == "buy") {
              $.get(
                `${window.Shopify.routes.root}cart?view=minicart`,
                function (itemData) {
                  var item_count = jQuery(itemData)
                    .find("#cart-notification-button .count")
                    .text();
                  if ($(".cart-count-bubble").length > 0) {
                    $(".cart-count-bubble span").text(item_count);
                  } else {
                    $("#cart-icon-bubble").append(
                      '<div class="cart-count-bubble"><span></span></div>'
                    );
                    $(".cart-count-bubble span").text(item_count);
                  }
                  $("#cart-notification").text("");
                  var textreplace = "<div id='min-cart-replace'></div>";
                  $("#cart-notification").append(textreplace);
                  $("#cart-notification").replaceWith(itemData);
                  $("#cart-notification").addClass("minicart-active");
                  $("#cart-notification").css("visibility", "hidden");
                  $(".cart-count-bubble").css("visibility", "hidden");
                  window.location.href = `${window.Shopify.routes.root}checkout`;
                }
              );
            } else {
              $.get(
                `${window.Shopify.routes.root}cart?view=minicart`,
                function (itemData) {
                  var item_count = jQuery(itemData)
                    .find("#cart-notification-button .count")
                    .text();
                  if ($(".cart-count-bubble").length > 0) {
                    $(".cart-count-bubble span").text(item_count);
                  } else {
                    $("#cart-icon-bubble").append(
                      '<div class="cart-count-bubble"><span></span></div>'
                    );
                    $(".cart-count-bubble span").text(item_count);
                  }
                  $("#cart-notification").text("");
                  var textreplace = "<div id='min-cart-replace'></div>";
                  $("#cart-notification").append(textreplace);
                  $("#cart-notification").replaceWith(itemData);
                  $("#cart-notification").addClass("minicart-active");
                }
              );
              var main_product_sku = $("#main-pro-sku").val();

              var productCategory = $(".pdp_product_category").attr("value");
              var productCurrency = $(".pdp_product_currency").attr("value");
              var productPrice1 = $(".pdp_product_price").attr("value");
              var productPrice = $("#prod_price_" + prodVariantID).val();
              var productTitle = $(".pdp_product_title").attr("value");
              var prodQuant = $("#prodQuantity").val();
              //souvik code for product list trackingends
              //souvik code for product list tracking starts
              //cartCookie(mpn_handle, prodVariantID, productList);
              //  triggerGAAddToCart(productcomPrice, mpn_handle, productTitle, productCategory, productList, productCurrency, productPrice, prodQuant, main_product_sku, prodVariantID);
              //souvik code for product list tracking ends
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            return false;
          })
          .finally(() => {
            disablePdpButton(false);
            // checkQuantity();
            //  submitButton.classList.remove('loading');
            //  submitButton.removeAttribute('aria-disabled');
            // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      } else if (isChecked == true && isChecked2 == false) {
        // alert('Applecare true, sec warranty false');
        //return false;
        var prodMaxqut = $("#product_max_quantity").val();
        var applecareID = $("#apple-care-varid").val(); //Getting apple care id
        var applecaresku = $("#applecare-product-sku").val(); //Getting apple care sku
        var applecarempn = $("#applecare-product-mpn").val(); //Getting apple care mpn
        var applecarehandle = $("#applecare-product-handle").val(); //Getting apple care handle
        var main_product_sku = $("#main-pro-sku").val(); //Getting MAIN PRODUCT SKU
        var main_product_handle = $("#main-pro-handle").val(); //Getting main product handle
        var main_product_preorder = $("#main-pro-preorder").val(); //Getting main product preorder value
        var main_product_preorder_message = $(
          "#main-pro-preorder-message"
        ).val(); //Getting main product preorder message value
        var main_product_trade_in = $("#main-pro-trade-in").val(); //Getting main product trade-in value
        var prodVariantID = $("#main-product-variant").val(); //Getting main product id
        var prodQuant = $("#prodQuantity").val(); //Getting main product QUANTITY
        var taxtags = $("#tax_tags").val();
        var uid = main_product_handle + "-" + applecarehandle;
        if (tradeInDevice && !uid.includes("tradein")) {
          uid = uid + "-tradein";
        }

        const props = {
          _applecare_sku: applecaresku,
          _applecare_handle: applecarehandle,
          _uuid: uid,
          ...(main_product_preorder === "true" && { _preOrder: "true" }),
          ...(main_product_preorder_message && {
            _preOrderMessage: main_product_preorder_message,
          }),
          ...(main_product_trade_in === "true" && { _tradeInEligible: "true" }),
        };

        if (hasTradeIn === true) {
          props._tradeIn_value = parsedTradeInValue;
          props._tradeIn_device = tradeInDevice;
          props._tradeInEligible = "true";
        }
        const adobeItems = [
          {
            id: applecareID,
            quantity: prodQuant,
          },
          {
            id: prodVariantID,
            quantity: prodQuant,
          },
        ];
        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "post",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: applecareID,
                quantity: prodQuant,
                properties: {
                  _aplcr_main_product_sku: main_product_sku,
                  _aplcr_main_product_handle: main_product_handle,
                  _uuid: uid,
                },
              },
              {
                id: prodVariantID,
                quantity: prodQuant,
                properties: props,
              },
            ],
          }),
        })
          /* Applecare PDP  ends here - added by Hema*/
          .then((response) => {
            response.json().then((d) => {
              if ($(".pdp_product_list").attr("value").indexOf("PLP ::") >= 0) {
                var proliststring = $(".pdp_product_list").attr("value");
              } else {
                var proliststring = formatString(
                  $(".pdp_product_list").attr("value")
                );
              }
              var productList = proliststring;
              cartCookie(mpn_handle, d.items[1].key, productList);

              triggerGAAddToCart(
                productcomPrice,
                mpn_handle,
                productTitle,
                productCategory,
                productList,
                productCurrency,
                productPrice,
                prodQuant,
                main_product_sku,
                prodVariantID
              );

              if ($cartDrawer) {
                $cartDrawer.updateItems();
              }
              adobeTrack(adobeItems);
            });
            if (check_buy == "buy") {
              $.get(
                `${window.Shopify.routes.root}cart?view=minicart`,
                function (itemData) {
                  var item_count = jQuery(itemData)
                    .find("#cart-notification-button .count")
                    .text();
                  if ($(".cart-count-bubble").length > 0) {
                    $(".cart-count-bubble span").text(item_count);
                  } else {
                    $("#cart-icon-bubble").append(
                      '<div class="cart-count-bubble"><span></span></div>'
                    );
                    $(".cart-count-bubble span").text(item_count);
                  }
                  $("#cart-notification").text("");
                  var textreplace = "<div id='min-cart-replace'></div>";
                  $("#cart-notification").append(textreplace);
                  $("#cart-notification").replaceWith(itemData);
                  $("#cart-notification").addClass("minicart-active");
                  $("#cart-notification").css("visibility", "hidden");
                  $(".cart-count-bubble").css("visibility", "hidden");
                  window.location.href = `${window.Shopify.routes.root}checkout`;
                }
              );
            } else {
              $.get(
                `${window.Shopify.routes.root}cart?view=minicart`,
                function (itemData) {
                  var item_count = jQuery(itemData)
                    .find("#cart-notification-button .count")
                    .text();
                  if ($(".cart-count-bubble").length > 0) {
                    $(".cart-count-bubble span").text(item_count);
                  } else {
                    $("#cart-icon-bubble").append(
                      '<div class="cart-count-bubble"><span></span></div>'
                    );
                    $(".cart-count-bubble span").text(item_count);
                  }
                  $("#cart-notification").text("");
                  var textreplace = "<div id='min-cart-replace'></div>";
                  $("#cart-notification").append(textreplace);
                  $("#cart-notification").replaceWith(itemData);
                  $("#cart-notification").addClass("minicart-active");
                }
              );
              var main_product_sku = $("#main-pro-sku").val();

              var productCategory = $(".pdp_product_category").attr("value");
              var productCurrency = $(".pdp_product_currency").attr("value");
              var productPrice1 = $(".pdp_product_price").attr("value");
              var productPrice = $("#prod_price_" + prodVariantID).val();
              var productTitle = $(".pdp_product_title").attr("value");
              var prodQuant = $("#prodQuantity").val();
              //souvik code for product list trackingends
              //souvik code for product list tracking starts
              //cartCookie(mpn_handle, prodVariantID, productList);
              // triggerGAAddToCart(productcomPrice, mpn_handle, productTitle, productCategory, productList, productCurrency, productPrice, prodQuant, main_product_sku, prodVariantID);
              //souvik code for product list tracking ends
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            return false;
          })
          .finally(() => {
            disablePdpButton(false);
            //  checkQuantity();
            // submitButton.classList.remove('loading');
            //  submitButton.removeAttribute('aria-disabled');
            //  this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      } else if (hasTradeIn === true) {
        const prodMaxqut = $("#product_max_quantity").val();
        const main_product_sku = $("#main-pro-sku").val(); // Get MAIN PRODUCT SKU
        const main_product_handle = $("#main-pro-handle").val(); // Get main product handle
        const main_product_preorder = $("#main-pro-preorder").val(); // Get main product preorder value
        const main_product_preorder_message = $(
          "#main-pro-preorder-message"
        ).val(); // Get main product preorder message value
        var main_product_trade_in = $("#main-pro-trade-in").val(); //Getting main product trade-in value
        const prodVariantID = $("#main-product-variant").val(); // Get main product id
        const prodQuant = $("#prodQuantity").val(); // Get main product QUANTITY
        const taxtags = $("#tax_tags").val();

        const adobeItems = [
          {
            id: prodVariantID,
            quantity: prodQuant,
          },
        ];

        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "post",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: prodVariantID,
                quantity: prodQuant,
                properties: {
                  _tradeIn_value: parsedTradeInValue,
                  _tradeIn_device: tradeInDevice,
                  _tradeInEligible: "true",
                  _uuid: main_product_handle,
                  ...(main_product_preorder === "true" && {
                    _preOrder: "true",
                  }),
                  ...(main_product_preorder_message && {
                    _preOrderMessage: main_product_preorder_message,
                  }),
                  ...(main_product_trade_in === "true" && {
                    _tradeInEligible: "true",
                  }),
                },
              },
            ],
          }),
        })
          /* Trade-In PDP ends here */
          .then((response) => {
            response.json().then((d) => {
              if ($(".pdp_product_list").attr("value").indexOf("PLP ::") >= 0) {
                var proliststring = $(".pdp_product_list").attr("value");
              } else {
                var proliststring = formatString(
                  $(".pdp_product_list").attr("value")
                );
              }

              var productList = proliststring;

              cartCookie(mpn_handle, d.items[0].key, productList);
              triggerGAAddToCart(
                productcomPrice,
                mpn_handle,
                productTitle,
                productCategory,
                productList,
                productCurrency,
                productPrice,
                prodQuant,
                main_product_sku,
                prodVariantID
              );

              if ($cartDrawer) {
                $cartDrawer.updateItems();
              }
              adobeTrack(adobeItems);
            });

            if (check_buy == "buy") {
              $.get(
                `${window.Shopify.routes.root}cart?view=minicart`,
                function (itemData) {
                  var item_count = jQuery(itemData)
                    .find("#cart-notification-button .count")
                    .text();
                  if ($(".cart-count-bubble").length > 0) {
                    $(".cart-count-bubble span").text(item_count);
                  } else {
                    $("#cart-icon-bubble").append(
                      '<div class="cart-count-bubble"><span></span></div>'
                    );
                    $(".cart-count-bubble span").text(item_count);
                  }
                  $("#cart-notification").text("");
                  var textreplace = "<div id='min-cart-replace'></div>";
                  $("#cart-notification").append(textreplace);
                  $("#cart-notification").replaceWith(itemData);
                  $("#cart-notification").addClass("minicart-active");
                  $("#cart-notification").css("visibility", "hidden");
                  $(".cart-count-bubble").css("visibility", "hidden");
                  window.location.href = `${window.Shopify.routes.root}checkout`;
                }
              );
            } else {
              $.get(
                `${window.Shopify.routes.root}cart?view=minicart`,
                function (itemData) {
                  var item_count = jQuery(itemData)
                    .find("#cart-notification-button .count")
                    .text();
                  if ($(".cart-count-bubble").length > 0) {
                    $(".cart-count-bubble span").text(item_count);
                  } else {
                    $("#cart-icon-bubble").append(
                      '<div class="cart-count-bubble"><span></span></div>'
                    );
                    $(".cart-count-bubble span").text(item_count);
                  }
                  $("#cart-notification").text("");
                  var textreplace = "<div id='min-cart-replace'></div>";
                  $("#cart-notification").append(textreplace);
                  $("#cart-notification").replaceWith(itemData);
                  $("#cart-notification").addClass("minicart-active");
                }
              );

              var main_product_sku = $("#main-pro-sku").val();
              var productCategory = $(".pdp_product_category").attr("value");
              var productCurrency = $(".pdp_product_currency").attr("value");
              var productPrice1 = $(".pdp_product_price").attr("value");
              var productPrice = $("#prod_price_" + prodVariantID).val();
              var productTitle = $(".pdp_product_title").attr("value");
              var prodQuant = $("#prodQuantity").val();
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            return false;
          })
          .finally(() => {
            disablePdpButton(false);
          });
      }
    } else {
      var main_product_handle = $("#main-pro-handle").val();
      var main_product_preorder = $("#main-pro-preorder").val();
      var main_product_preorder_message = $("#main-pro-preorder-message").val();
      var main_product_trade_in = $("#main-pro-trade-in").val();
      var main_product_sku = $("#main-pro-sku").val();
      var prodQuant = $("#prodQuantity").val();
      var prodVariantID = $("#main-product-variant").val();

      const adobeItems = [
        {
          id: prodVariantID,
          quantity: prodQuant,
        },
      ];

      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "post",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: prodVariantID,
              quantity: prodQuant,
              properties: {
                _uuid: main_product_handle,
                ...(main_product_preorder === "true" && { _preOrder: "true" }),
                ...(main_product_preorder_message && {
                  _preOrderMessage: main_product_preorder_message,
                }),
                ...(main_product_trade_in === "true" && {
                  _tradeInEligible: "true",
                }),
              },
            },
          ],
        }),
      })
        .then((response) => {
          response.json().then((d) => {
            if ($(".pdp_product_list").attr("value").indexOf("PLP ::") >= 0) {
              var proliststring = $(".pdp_product_list").attr("value");
            } else {
              var proliststring = formatString(
                $(".pdp_product_list").attr("value")
              );
            }
            var productList = proliststring;
            cartCookie(mpn_handle, d.items[0].key, productList);
            triggerGAAddToCart(
              productcomPrice,
              mpn_handle,
              productTitle,
              productCategory,
              productList,
              productCurrency,
              productPrice,
              prodQuant,
              main_product_sku,
              prodVariantID
            );

            if ($cartDrawer) {
              $cartDrawer.updateItems();
            }
            adobeTrack(adobeItems);
          });
          if (check_buy == "buy") {
            $.get(
              `${window.Shopify.routes.root}cart?view=minicart`,
              function (itemData) {
                var item_count = jQuery(itemData)
                  .find("#cart-notification-button .count")
                  .text();
                if ($(".cart-count-bubble").length > 0) {
                  $(".cart-count-bubble span").text(item_count);
                } else {
                  $("#cart-icon-bubble").append(
                    '<div class="cart-count-bubble"><span></span></div>'
                  );
                  $(".cart-count-bubble span").text(item_count);
                }
                $("#cart-notification").text("");
                var textreplace = "<div id='min-cart-replace'></div>";
                $("#cart-notification").append(textreplace);
                $("#cart-notification").replaceWith(itemData);
                $("#cart-notification").addClass("minicart-active");
                $("#cart-notification").css("visibility", "hidden");
                $(".cart-count-bubble").css("visibility", "hidden");
                window.location.href = `${window.Shopify.routes.root}checkout`;
              }
            );
          } else {
            $.get(
              `${window.Shopify.routes.root}cart?view=minicart`,
              function (itemData) {
                var item_count = jQuery(itemData)
                  .find("#cart-notification-button .count")
                  .text();
                if ($(".cart-count-bubble").length > 0) {
                  $(".cart-count-bubble span").text(item_count);
                } else {
                  $("#cart-icon-bubble").append(
                    '<div class="cart-count-bubble"><span></span></div>'
                  );
                  $(".cart-count-bubble span").text(item_count);
                }
                $("#cart-notification").text("");
                var textreplace = "<div id='min-cart-replace'></div>";
                $("#cart-notification").append(textreplace);
                $("#cart-notification").replaceWith(itemData);
                $("#cart-notification").addClass("minicart-active");
              }
            );
            var main_product_sku = $("#main-pro-sku").val();

            var productCategory = $(".pdp_product_category").attr("value");
            var productCurrency = $(".pdp_product_currency").attr("value");
            var productPrice1 = $(".pdp_product_price").attr("value");
            var productPrice = $("#prod_price_" + prodVariantID).val();
            var productTitle = $(".pdp_product_title").attr("value");
            var prodQuant = $("#prodQuantity").val();
            //souvik code for product list trackingends
            //souvik code for product list tracking starts
            //  cartCookie(mpn_handle, prodVariantID, productList);
            //    triggerGAAddToCart(productcomPrice, mpn_handle, productTitle, productCategory, productList, productCurrency, productPrice, prodQuant, main_product_sku, prodVariantID);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          disablePdpButton(false);
          // checkQuantity();
        });
    }
  }

  function cartCookie(mpn_handle, prodVariantID, productList) {
    var prevPage = document.referrer;
    var search_value = "";
    var first_search = "";
    if (prevPage.includes("search")) {
      first_search = localStorage.getItem("search_value");
      search_value = localStorage.getItem("search_value_term");
      if (first_search == null) {
        localStorage.setItem("search_value", search_value);
        var first_search_str = localStorage.getItem("search_value");
        first_search = formatString(first_search_str);
      }
    }
    var exphone = [];
    var item_cart = {};
    item_cart["cart_item_id"] = prodVariantID;
    item_cart["cart_item_list_name"] = productList;
    item_cart["cart_item_mpn"] = mpn_handle;
    item_cart["cart_search_term"] = first_search;
    if (JSON.parse(localStorage.getItem("cart")) != null) {
      exphone = JSON.parse(localStorage.getItem("cart"));
    }
    exphone.push(item_cart);
    localStorage.setItem("cart", JSON.stringify(exphone));
    // console.log(JSON.parse(localStorage.getItem("cart")));
  }

  function triggerGAAddToCart(
    productcomPrice,
    mpn,
    productTitle,
    productCategory,
    productList,
    productCurrency,
    productPrice,
    prodQuant,
    main_product_sku,
    prod_variantID
  ) {
    var prevPage = document.referrer;
    var search_value = "";
    if (prevPage.includes("search")) {
      var first_search = localStorage.getItem("search_value");
      search_value = localStorage.getItem("search_value_term");
      if (first_search == null) {
        localStorage.setItem("search_value", search_value);
        var first_search_str = localStorage.getItem("search_value");
        first_search = formatString(first_search_str);
      }
    }
    dataLayer.push({
      ecommerce: null,
    });
    //productPrice = Number(productPrice.replace(/[^0-9.-]+/g, ""));
    productPrice = Number(productPrice?.replace(/[^0-9.-]+/g, ""));
    var value_price = productPrice * parseInt(prodQuant);
    var discount = 0;
    var value_price1 = parseFloat(value_price);
    var productPrice1 = parseFloat(productPrice);
    dataLayer.push({
      event: "add_to_cart",
      search_term: search_value,
      currency: productCurrency,
      value: value_price1,
      ecommerce: {
        items: [
          {
            item_id: mpn,
            item_name: productTitle,
            item_category: productCategory,
            item_list_name: productList,
            price: productPrice1,
            quantity: parseInt(prodQuant),
          },
        ],
      },
    });
  }

  function formatString(str) {
    return str
      .replace(/(\B)[^ ]*/g, (match) => match.toLowerCase())
      .replace(/^[^ ]/g, (match) => match.toUpperCase());
  }

  /* Minicart starts here - added by Hema*/
  function miniCart() {
    $.get(
      `${window.Shopify.routes.root}cart?view=minicart`,
      function (itemData) {
        $("cart-notification").replaceWith(itemData);
        $("#cart-notification").addClass("minicart-active");
        $.ajax({
          type: "GET",
          dataType: "json",
          url: `${window.Shopify.routes.root}cart.js`,
          success: function (cart) {
            let total = cart.item_count;
            $(".cart-count-bubble").text(total);
          },
        });
      }
    );
  }

  if ($productGrid) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation?.type === "childList") {
          // reinit quick add buttons
          quickAddEvents();
        }
      });
    });
    observer.observe($productGrid, { childList: true });
  }

  $("#prodQuantity").on("change", function () {
    debounce(checkQty, 500)();
  });

  function checkQty() {
    var productId = $("#product_id").val();
    var productQty = $("#prodQuantity").val();
    var prodMaxQty = $("#product_max_quantity").val();
    var prodInventoryQuantity = $("#productInventoryQuantity").val();
    var $errorMessage = document.querySelector(".js-qty-error") || null;
    var $qtyInput = document.querySelector(".js-qty-input") || null;
    var $pickUpAvailability =
      document.querySelectorAll("pickup-availability") || null;
    var $storeLocator = document.querySelector("my-store-locator") || null;

    if ($storeLocator && $pickUpAvailability?.length > 0 && productQty) {
      [...$pickUpAvailability].forEach((el) => {
        var locationId = $storeLocator.preferredStoreId || null;
        el.dataset.itemQuantity = productQty ? parseInt(productQty) : null;

        if (locationId) {
          var location =
            $storeLocator?.allLocationsData?.find(
              (loc) => loc.id === locationId
            ) || null;
          if (location) {
            el.renderPreview(location);
          }
        }
      });
    }

    var maxQty = checkMaxquantity(productId);

    if (maxQty != "") {
      var maxQtyAllowed = parseInt(productQty) + parseInt(maxQty);
    } else {
      var maxQtyAllowed = parseInt(productQty);
    }

    if (maxQtyAllowed > prodMaxQty) {
      if ($errorMessage) {
        const text = $errorMessage.innerHTML;

        if (text) {
          if (text.includes("{limit}")) {
            $errorMessage.innerHTML = text.replace(
              "{limit}",
              `(${prodMaxQty})`
            );
            $errorMessage.classList.remove("hidden");
          } else {
            $errorMessage.classList.remove("hidden");
          }
        }
      }
      if ($qtyInput) {
        $qtyInput.classList.add("quantity--error");
      }
      return false;
    } else if (maxQtyAllowed > parseInt(prodInventoryQuantity)) {
      if ($errorMessage) {
        const maxLevel = parseInt(prodInventoryQuantity);
        const text = $errorMessage.innerHTML;

        if (text) {
          if (text.includes("{limit}")) {
            $errorMessage.innerHTML = text.replace("{limit}", `(${maxLevel})`);
            $errorMessage.classList.remove("hidden");
          } else {
            $errorMessage.classList.remove("hidden");
          }
        }
      }

      if ($qtyInput) {
        $qtyInput.classList.add("quantity--error");
      }
      return false;
    } else {
      resetErrors();
      return true;
    }
  }

  function resetErrors() {
    var $errorMessage = document?.querySelector(".js-qty-error") || null;
    var $qtyInput = document?.querySelector(".js-qty-input") || null;

    if ($errorMessage) {
      $errorMessage.classList.add("hidden");
    }
    if ($qtyInput) {
      $qtyInput.classList.remove("quantity--error");
    }
  }
});
/* Minicart ends here - added by Hema*/

function checkMaxquantity(product_id) {
  var total_max_quantity = 0;
  var product_id = product_id;
  $.ajax({
    type: "GET",
    dataType: "json",
    async: false,
    url: `${window.Shopify.routes.root}cart.js`,
    success: function (cart) {
      for (var i = 0; i < cart.items.length; i++) {
        var product_cartid = cart.items[i].product_id;
        if (product_cartid == product_id) {
          total_max_quantity += cart.items[i].quantity;
        }
      }
    },
  });
  return total_max_quantity;
}

function checkQuantity() {
  var total_quantity = 0;
  var cart_key = [];
  $.ajax({
    type: "GET",
    dataType: "json",
    url: `${window.Shopify.routes.root}cart.js`,
    success: function (cart) {
      for (var i = 0; i < cart.items.length; i++) {
        var tags = cart.items[i].properties.__taxtags;
        if (tags != undefined) {
          var list = tags.split(",");
          var found = false;
          for (var j = 0; j < list.length; ++j) {
            cart_key.push(cart.items[i].properties.__taxtags);
            if (list[j] == "taxfree") {
              total_quantity += cart.items[i].quantity;
            }
          }
        }
      }
      setCookie("total_quantity", total_quantity, 7);
      setCookie("cart_key", cart_key, 7);
    },
  });
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
